import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { IPromoSectionProps } from '../components/promo-section/promo-section';
import { ThemeVariantType } from '../typings';

export class PromoSectionModel extends ContentItem {
  get text(): string {
    return get(this._config, 'elements.body.value', '');
  }
  get backgroundAsset(): string {
    return get(this._config, 'elements.background.value[0].url', '');
  }

  get themeVariant(): ThemeVariantType {
    return get(
      this._config,
      'elements.theme_schema__theme_type.value[0].codename',
      ''
    );
  }
  get textParameters(): string[] {
    const getTextParameters = get(
      this._config,
      'elements.text_parameters__add_styles.value',
      []
    );
    const arrayOfStyles: string[] = [];

    getTextParameters &&
      getTextParameters.map(
        (param: IKontentTaxonomyItem, i: number) =>
          (arrayOfStyles[i] = param.codename)
      );
    return arrayOfStyles as string[];
  }

  public static create(data: IPromoSection): IPromoSectionProps {
    const {
      text,
      backgroundAsset,
      themeVariant,
      textParameters
    } = new PromoSectionModel(data);
    return {
      text,
      backgroundAsset,
      themeVariant,
      textParameters
    };
  }
}
